import axios from 'axios'
import { UrlBase } from './config'

const cancelToken = axios.CancelToken
let sourceDailyUsage = cancelToken.source()
let sourceDetailedUsage = cancelToken.source()
let sourcePayments = cancelToken.source()
let sourceCreditCardList = cancelToken.source()
let sourceCreditCardListOfCompany = cancelToken.source()

const payments = {}

payments.changeCardPriorityToMain = async (token, companyId, cardId) => {
  try {
    const request = {
      data: {
        toChange: cardId
      },
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'POST',
      url: UrlBase + `companies/${companyId}/payments/cards/change/to/main`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

payments.chargeBalance = async (token, { amount, companyId, description, gift, invoice }) => {
  try {
    const request = {
      data: {
        amount,
        description,
        gift,
        invoice
      },
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'POST',
      url: UrlBase + `companies/${companyId}/add/balance`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

payments.deleteCard = async (token, companyId, cardId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/payments/cards/${cardId}`
    }

    return await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

payments.getChargeTypes = (token, companyId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/charge/types'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

payments.getDailyUsage = (token, companyId, { search, chargeType, date, fromDate, toDate }, pagination) => {
  sourceDailyUsage.cancel('Operation canceled')
  sourceDailyUsage = cancelToken.source()
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search
      },
      url: UrlBase + 'companies/' + companyId + '/payments/transactions/',
      cancelToken: sourceDailyUsage.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') {
          const message = error.response
          if (!message) return reject(new Error(error.message))
          else return reject(new Error(message.data.error))
        }
      })
  })
}

payments.getDetailedUsage = (token, companyId, { search, description, chargeType, date, fromDate, toDate }, pagination) => {
  sourceDetailedUsage.cancel('Operation canceled')
  sourceDetailedUsage = cancelToken.source()
  return new Promise((resolve, reject) => {
    // temporary solution for date range:
    if (date) {
      fromDate = `${date} 00:00:00`
      toDate = `${date} 23:59:59`
    }
    // console.log('date')
    // console.log(date)
    // console.log(fromDate)
    // console.log(toDate)
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search,
        description,
        chargeType,
        fromDate,
        toDate
        // date
      },
      url: UrlBase + 'companies/' + companyId + '/payments/transactions/movements',
      cancelToken: sourceDetailedUsage.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') {
          const message = error.response
          if (!message) return reject(new Error(error.message))
          else return reject(new Error(message.data.error))
        }
      })
  })
}

payments.getPayments = (token, companyId, { search, status, payload, date, fromDate, toDate }, pagination) => {
  sourcePayments.cancel('Operation canceled')
  sourcePayments = cancelToken.source()
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search,
        status,
        payload
      },
      url: UrlBase + 'companies/' + companyId + '/payments',
      cancelToken: sourcePayments.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') {
          const message = error.response
          if (!message) return reject(new Error(error.message))
          else return reject(new Error(message.data.error))
        }
      })
  })
}

payments.getListCreditCards = async (token, companyId) => {
  try {
    sourceCreditCardList.cancel('Operation canceled')
    sourceCreditCardList = cancelToken.source()

    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: null,
        sortBy: null,
        descending: null,
        limit: 1000
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards',
      cancelToken: sourceCreditCardList.token
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

payments.getListCreditCardsOfCompany = async (token, companyId, data) => {
  try {
    const { search, name, last4Digits, priority } = data
    sourceCreditCardListOfCompany.cancel('Operation canceled')
    sourceCreditCardListOfCompany = cancelToken.source()

    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: null,
        sortBy: null,
        descending: null,
        limit: 1000,
        search,
        name,
        last4Digits,
        priority
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards',
      cancelToken: sourceCreditCardListOfCompany.token
    }

    const response = await axios(request)
    return response.data.paymentCards.rows
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

payments.getTransactionMovements = async (token, companyId, filename) => {
  try {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + `companies/${companyId}/payments/transactions/export/charges`
    }

    const response = await axios(request)
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${filename}.xlsx`)
    document.body.appendChild(link)
    link.click()
    return true
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

payments.addCreditCard = async (token, companyId, data) => {
  const {
    expiryYear,
    expiryMonth,
    cardNumber,
    cvc,
    docNumber,
    docType,
    holderName,
    holderLastName,
    brand,
    transactionProvider,
    city,
    country,
    cellPhone,
    address
  } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards',
      data: {
        expiry_year: expiryYear,
        expiry_month: expiryMonth,
        card_number: cardNumber,
        cvc: cvc,
        doc_number: docNumber,
        doc_type: docType,
        holderName: holderName,
        holderLastName: holderLastName,
        brand: brand,
        transactionProvider: transactionProvider,
        city: city,
        address: address,
        cellPhone: cellPhone,
        country: country.substr(0, 2)
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}
payments.addCreditCardStripe = async (token, companyId, data) => {
  const { cardToken, transactionProvider } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards',
      data: {
        cardToken,
        transactionProvider
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

payments.addCreditCardPaymentez = async (token, companyId, data) => {
  try {
    const {
      transactionProvider,
      cardToken,
      transactionReference,
      expiryYear,
      expiryMonth,
      type,
      last4Digits,
      holderName
    } = data

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards',
      data: {
        transactionProvider,
        cardToken,
        transaction_reference: transactionReference,
        expiry_year: expiryYear,
        expiry_month: expiryMonth,
        type,
        last4Digits,
        holderName
      }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

payments.chargeOwnAccount = async (token, companyId, data) => {
  try {
    const { amount, cardId } = data

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/payments/cards/payment',
      data: {
        amount,
        cardId
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

payments.newPaymentOtherCompany = async (token, data) => {
  try {
    const { amount, cardId, companyId } = data

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/charge',
      data: {
        amount,
        cardId
      }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default payments
